module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Gaida piegādi")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('skipped-goods-warning', {
    attrs: {
      "storeStatus": _vm.cartStoreStatus
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ui selectable table orange"
  }, [_c('div', {
    staticClass: "ui loader",
    class: {
      active: _vm.storeStatus.loading
    }
  }), _vm._v(" "), (!_vm.checkClientWidth) ? _c('thead', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', {
      class: {
        warning: item.status == 0
      }
    }, [_c('td', [_vm._v(_vm._s(item.delivery_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total_amount_with_bail_and_vat) + " €")]), _vm._v(" "), (item.status == 3) ? _c('td', [_c('i', {
      staticClass: "clock icon"
    }), _vm._v(" Tiek apstrādāts")]) : (item.status == 4) ? _c('td', [_c('i', {
      staticClass: "hourglass start icon"
    }), _vm._v(" Gaida piegādi")]) : _c('td', [_c('i', {
      staticClass: "warning attention icon"
    }), _vm._v(" Atcelts")]), _vm._v(" "), _c('td', [(item.lock == 0 && item.status == 3) ? _c('button', {
      staticClass: "ui custom_brown button",
      on: {
        "click": function($event) {
          return _vm.goToEditPage(item)
        }
      }
    }, [_vm._v("Rediģēt")]) : _vm._e(), _vm._v(" "), ((item.lock == 1 && item.status == 3) || item.status == 4) ? _c('button', {
      staticClass: "ui custom_brown button",
      on: {
        "click": function($event) {
          return _vm.goToEditPage(item)
        }
      }
    }, [_vm._v("Apskatīt")]) : _vm._e(), _vm._v(" "), (item.status == 3 && item.autoship_id <= 0) ? _c('button', {
      staticClass: "ui custom_brown icon button",
      on: {
        "click": function($event) {
          return _vm.cancelOrder(item)
        }
      }
    }, [_c('i', {
      staticClass: "right trash icon"
    })]) : _vm._e(), _vm._v(" "), (item.autoship_id > 0) ? _c('router-link', {
      staticClass: "ui custom_brown icon button",
      attrs: {
        "to": {
          name: 'autoship'
        }
      }
    }, [_c('i', {
      staticClass: "right share icon"
    })]) : _vm._e()], 1)])
  }), 0)])], 1), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "waiting-delivery-delete-dialog"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "ui custom_brown ok inverted button",
    on: {
      "click": _vm.deleteOrder
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Jā\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Piegādes datums")]), _vm._v(" "), _c('th', [_vm._v("Adrese")]), _vm._v(" "), _c('th', [_vm._v("Kopsumma")]), _vm._v(" "), _c('th', [_vm._v("Statuss")]), _vm._v(" "), _c('th', [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v("\n      Vai dzēst ierakstu?\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Dzēšot Pasūtījumu, iepriekš samaksātā summa tiks atgriezta uz jūsu kontu!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui grey basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        Nē\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2586ad0e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WaitingForDeliveryPage.vue
// module id = 330
// module chunks = 1